import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-infopage',
  templateUrl: './infopage.page.html',
  styleUrls: ['./infopage.page.scss'],
})
export class InfoPage {
  //declared variables
  public assets = environment.assets;
  //constructor
  constructor() { }
  //opens email client (iOS workaround)
  public openEmail(email) {
    window.location.href = 'mailto:'+ email; 
    return false;
  }

}
